export default {
	user: 'Client',
	admin: 'Admin',
	manager: 'Manager',
	super: 'Superadmin',
	addRole: 'Add Role',
	name: 'Title',
	alias: 'alias',
	description: 'Description',
	permissions: 'Features',
	roleEdit: 'Editing a role',
	areYouSureYouWantToDeleteRole: 'Are you sure you want to delete the role?'
};
